import React, { useState, useEffect } from 'react';
import axios from "axios";
import { baseUrl } from "../../shared/baseUrl";
import { useSelector } from 'react-redux';
import { NavLink, useNavigate, Link } from 'react-router-dom';
import Header from '../../components/admin/Header';
import SideBar from '../../components/admin/SideBar';
import Modal  from 'react-modal';
import { VscChromeClose } from 'react-icons/vsc';
import { MdAddAPhoto, MdPending, MdCheckCircle, MdCloudUpload, MdDelete } from 'react-icons/md';
import { FaEye, FaLink } from 'react-icons/fa';
import { BsUpload } from 'react-icons/bs';
import ReactPaginate from "react-paginate";
import TableHandler from '../../components/admin/TableHandler';
import Swal from 'sweetalert2';

const MyListing = () => {
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    }
  }

  const navigate = useNavigate()

  Modal.setAppElement('#root')

  const [toggleNav, setToggleNav] = useState(false)

  const [openImgModal, setOpenImgModal] = useState(false)

  const [category, setCategory] = useState("all")
  const [data, setData] = useState([])
  const [filterData, setFilterData] = useState([])
  const [propDetails, setPropDetails] = useState({})
  const [propertyId, setPropertyId] = useState("")
  const [imgPreview, setImgPreview] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loadingList, setLoadingList] = useState(false)
  const [errorList, setErrorList] = useState(null)

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  // --- Pagination --- //
  const [pageNumber, setPageNumber] = useState(0)
  const itemsPerPage = 10
  const pagesVisited = pageNumber * itemsPerPage
  const pageCount = Math.ceil(data?.length / itemsPerPage)
  const changePage = ({ selected }) => setPageNumber(selected)
  const displayData = data?.slice(pagesVisited, pagesVisited + itemsPerPage)
  // --- Pagination --- //

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userInfo?.token}`
    }
  }

  useEffect(() => {
    document.title = "Island Luxury - Property Listing"
    if(!userInfo) {
			navigate('/')
		} 
    else {
      const getProperties = async () => {
        try {
          setLoadingList(true)
          const res = await axios.get(baseUrl + "/api/v1/properties/agent", config)
          setData(res.data.data)
          setFilterData(res.data.data)
          setLoadingList(false)
        }
        catch(err){
          setErrorList(err.response && err.response.data.message ? err.response.data.message : err.message)
        }
      }
      getProperties()
    }
  }, [userInfo, navigate])

  useEffect(() => {
    if(!openImgModal) {
      setImgPreview(null)
    }
  }, [openImgModal])

  // --- Category Filtering By Category --- //
  useEffect(() => {
    if(category === "all") {
      setData(filterData)
    } else {
      const results = filterData?.filter(item => (item.category.includes(category)))
      setData(results)
    }
  }, [category])

  // --- Handle Select Image --- //
  const handleChangeImg = (e) => {
    const file = e.target.files[0]
    setImgPreview(URL.createObjectURL(file))
    const formData = new FormData()
    formData.append('image', file)

    const postImg = async () => {
      try {
        setLoading(true)
        await axios.post(baseUrl + `/api/v1/imageupload/${propertyId}`, formData, config)
        Swal.fire({
          icon: 'success',
          title: 'Uploaded',
          text: "Your image have been saved!",
        })
        setLoading(false)
      }
      catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `${err.response && err.response.data.message ? err.response.data.message : err.message}, Please try again!`,
        })
        setLoading(false)
      }
    }
    postImg()
  }

  // --- Handle Delete Property --- //
  const handleDeleteProperty = (item) => {
    const deleteProperty = async () => {
      try {
        await axios.delete(baseUrl + `/api/v1/properties/${item._id}`, config)
        Swal.fire({
          icon: 'success',
          title: 'Delete',
          text: "You deleted a Property",
        })
      }
      catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `${err.response && err.response.data.message ? err.response.data.message : err.message}, please try again!`,
        })
      }
    }
    deleteProperty(item._id)
  }

  // --- Format Currency --- //
  const formatToCurrency = Intl.NumberFormat('en-US')

  return (
     <div id="admin-page_wrap">
      <Header toggleNav={toggleNav} setToggleNav={setToggleNav} />
      <SideBar toggleNav={toggleNav} />
      <main id="my-listing">
        <section className="page-title">
          <h3><NavLink to="/dashboard">Dashboard</NavLink> | My Listing</h3>
        </section>
        <section className="my-listing_cont">
          <div className="category-tab">
            <button className= "all" onClick={() => setCategory("all")}>All</button>
            <button className="rent" onClick={() => setCategory("Rent")}>Rent</button>
            <button className="sale" onClick={() => setCategory("Sale")}>Sale</button>
          </div>
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Type</th>
                <th>Price</th>
                <th>Location</th>
                <th>Category</th>
                <th>Bed(s)</th>
                <th>Bath(s)</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {!loadingList && (displayData?.map((item, index) => 
                <tr key={index}>
                  <td>{item.title}</td>
                  <td>{item.propertyType}</td>
                  <td>{formatToCurrency.format(item.price)}</td>
                  <td>{item.state}</td>
                  <td>
                    {item.category === "Rent" ?
                      <span className="table-rent">Rent</span>
                    :
                      <span className="table-sale">Sale</span>
                    }
                  </td>
                  <td>{item.bedrooms}</td>
                  <td>{item.bath}</td>
                  <td className="table-status">
                    {item.approved ? 
                      <div title="Approved">
                        <MdCheckCircle size={25} />
                      </div>
                    :
                      <div title="Pending">
                        <MdPending size={25} />
                      </div>
                    }
                  </td>
                  <td className="table-action">
                    <button className="img" onClick={() => {setOpenImgModal(true); setPropertyId(item._id)}} title="Add Image">
                      Add <MdAddAPhoto size={20} />
                    </button>
                    {item.approved && 
                      <Link to={`/property-details/${item._id}`} className="link" title="Product Web Page" target="_blank">
                        Link <FaLink size={20} />
                      </Link>
                    }
                    <button className="del" onClick={() => handleDeleteProperty(item)} title="Delete Property">
                      Del <MdDelete size={20} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <TableHandler data={data} loading={loadingList} error={errorList} />

          {data?.length > itemsPerPage &&
            <div className="pagination-tab">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                pageCount={pageCount}
                onPageChange={changePage}
                containerClassName={"paginationBttns"}
                previousLinkClassName={"previousBttn"}
                nextLinkClassName={"nextBttn"}
                disabledClassName={"paginationDisabled"}
                activeClassName={"paginationActive"} />
            </div>
					}

          <Modal 
            isOpen={openImgModal} 
            style={customStyles}
            closeTimeoutMS={200}> 
            <div className="modal-header">
              <h2>Add Images</h2>
              <button onClick={() => setOpenImgModal(false)}>
                <VscChromeClose size={25} />
              </button>
            </div>
            <div className="modal-body upload-img_modal">
              {imgPreview &&
                <div>
                  <img src={imgPreview} alt="Preview File" />
                </div> 
              }
              <label className="custom-upload">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleChangeImg}
                  disabled={loading && true} />
                {loading ? 
                  <>
                    <p>Uploading image...</p>
                  </>
                :
                  <>
                    <MdCloudUpload size={60} />
                    <p>Choose Image</p>
                  </>
                }
              </label>
              {/* <button 
                disabled={loading && true}
                onClick={handleUploadImg}>
                  {loading ? "Uploading..." : "Upload Image"}
              </button> */}
            </div>
          </Modal>

        </section>
      </main>
    </div>
  )
}

export default MyListing;